module.exports = __webpack_public_path__ + "img/no_location.0245a345.svg";